export default __webpack_public_path__ + "static/media/404-error.846dce2d.svg";